import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../shared/product.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { ToastrService } from 'ngx-toastr';
import { Product } from '../../shared/product.model';
import { CategoryService } from '../../shared/category.service';
import { Category } from '../../shared/category.model';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.css']
})
export class ProductListComponent implements OnInit {

  product: Product[];
  category: Category[];
  title: any;
  constructor(
    private service:ProductService,
    private cateservice:CategoryService,
    private firestore:AngularFirestore,
    private toastr : ToastrService) { }

  ngOnInit() {
    this.service.getProducts().subscribe(actionArray =>{
      this.product = actionArray.map(item => {
        const data = item.payload.doc.data() as Product;
        const id = item.payload.doc.id;
        return { id, ...data };
      })
    });

    
  }

  getCat(id: any){
    

    this.cateservice.getSingleCategory(id).subscribe(actionArray =>{
      this.category = actionArray.map(item => {
        const data = item as Category;
        return { ...data};
      })
    });
      

  }

  onEdit(pro:Product){
    this.service.productData = Object.assign({},pro);
  }

  onDelete(id: string){
    if(confirm("Are you sure to delete this Product?")){
      this.firestore.doc('products/' +id).delete();
      this.toastr.warning('Deleted Successfuly','Products');
    }
  }
  

}
